/*
    【ノベルティ適用処理】
*/
const noveltyInfoForMember = JSON.parse(document.getElementById("novelty-information-member").textContent);
const noveltyInfoForNonMember = JSON.parse(document.getElementById("novelty-information-non-member").textContent);

const applyNovelty = async (_sections,_sections_url) => {
    let returnValue = null;
    // ノベルティ情報
    // ※非会員の場合は、spendingが1以下のノベルティのみ適用
    const noveltyInfo = window.customer 
        ? noveltyInfoForMember.events
        : noveltyInfoForNonMember.events.filter(
            event => event.criteria[0].spending <= 1
        );

    const removeFormData =  {'updates':  {} },  // カートから削除するノベルティ
        addFormData = {items:[]};                 // カートに追加するノベルティ
    const cartContent = await (await fetch(`${routes.cart_url}.js`, {cache: 'reload'})).json();

    // noveltyInfoのitemsにない、かつ_purchaseEvent_IDに値をもつitemsを削除対象に追加
    cartContent.items.forEach(item => {
        if(item?.properties?._purchaseEvent_ID &&
            !noveltyInfo.find(event => event.criteria[0].items
            .find(noveltyItem => noveltyItem.shopifyVariant_ID === item.variant_id))){
            removeFormData.updates[item.key] = 0;
        }
    });

    // sampleSetItems : spendingが1以下のitemsを取得
    const sampleSetEvent = noveltyInfo.find(event => event.criteria[0].spending <= 1);
    // GWPEvent : spendingが1より大きいitemsを取得
    //       ※ GWPEvent → 顧客ログイン時のみ適用
    const GWPEvent = window.customer ? noveltyInfo.find(event => event.criteria[0].spending > 1) : null;

    if(GWPEvent && cartContent.total_price > (parseInt(GWPEvent.criteria[0].spending) * 100)){
        // (GWPEventあり) カート合計額がGWP適用条件金額以上の場合、GWP/Sampleアイテム共に適用

        // 1. GWPアイテムの適用
        GWPEvent.criteria[0]["items"].forEach(item => {
            const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
            if(!noveltyItem_InCart){
                addFormData["items"].push({
                    "id": item["shopifyVariant_ID"],
                    "quantity": item["qty"],
                    "properties": {
                        "_purchaseEvent_ID": GWPEvent["purchaseEvent_ID"],
                        "_discount_ID": item["discount_ID"],
                        "_purchaseEvent_Type": "GWP"
                    }
                });
            }
        });

        // 2. Sampleアイテムの適用
        sampleSetEvent.criteria[0]["items"].forEach(item => {
            const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
            if(!noveltyItem_InCart){
                addFormData["items"].push({
                    "id": item["shopifyVariant_ID"],
                    "quantity": item["qty"],
                    "properties": {
                        "_purchaseEvent_ID": sampleSetEvent["purchaseEvent_ID"],
                        "_discount_ID": item["discount_ID"],
                        "_purchaseEvent_Type": "SAMPLE"
                    }
                });
            }
        });

    }else if(cartContent.total_price > 0){
        // カート合計額が¥1円以上の場合、Sampleアイテムのみ適用
        // 1. GWPアイテムの削除
        if(GWPEvent) {
            GWPEvent.criteria[0]["items"].forEach(item => {
                const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
                if(noveltyItem_InCart){
                    removeFormData.updates[noveltyItem_InCart.key] = 0;
                }
            });
        }

        // 2. Sampleアイテムの適用
        sampleSetEvent.criteria[0]["items"].forEach(item => {
            const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
            if(!noveltyItem_InCart){
                addFormData["items"].push({
                    "id": item["shopifyVariant_ID"],
                    "quantity": item["qty"],
                    "properties": {
                        "_purchaseEvent_ID": sampleSetEvent["purchaseEvent_ID"],
                        "_discount_ID": item["discount_ID"],
                        "_purchaseEvent_Type": "SAMPLE"
                    }
                });
            }
        });
    }else {
        // カート合計額が¥0円の場合、ノベルティ適用なし
        // 1. GWPアイテムの削除
        if(GWPEvent) {
            GWPEvent.criteria[0]["items"].forEach(item => {
                const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
                if(noveltyItem_InCart){
                    removeFormData.updates[noveltyItem_InCart.key] = 0;
                }
            });
        }

        // 2. Sampleアイテムの削除
        sampleSetEvent.criteria[0]["items"].forEach(item => {
            const noveltyItem_InCart = cartContent["items"].find(cartItem => cartItem["variant_id"] === item["shopifyVariant_ID"]);
            if(noveltyItem_InCart){
                removeFormData.updates[noveltyItem_InCart.key] = 0;
            }
        });

    }

    // ノベルティ追加処理
    if(addFormData.items.length > 0){
        addFormData["sections"] = _sections;
        addFormData["sections_url"] = _sections_url;

        await fetch(`/cart/add.js`, {
          method: 'POST',
          headers: {
            'dataType': 'json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addFormData)
        })
          .then(response => response.text())
          .then((data) => {
            if(JSON.parse(data).sections){
                // 更新に成功し、レンダリング結果が返って来れば
                returnValue = data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    }


    // ノベルティ削除処理
    if(Object.keys(removeFormData.updates).length > 0){
        removeFormData["sections"] = _sections;
        removeFormData["sections_url"] = _sections_url;

        await fetch('/cart/update.js', { 
          method: 'POST', 
          headers: { 
            'dataType': 'json',
            'Content-Type': 'application/json' 
          }, 
          body: JSON.stringify(removeFormData) 
        }) 
          .then(response => response.text())
          .then(data => {      
            if(JSON.parse(data).sections){
                returnValue = data;
            }
          }) 
          .catch((error) => { 
            console.error(error); 
          });
      }

      return returnValue;
}


/*
    【初期表示時チェック】
    ページ初期表示時にノベルティ適用処理を実行
*/

document.addEventListener('DOMContentLoaded', async () => {
    const reRenderSections = [];
    if(document.getElementById('CartDrawer')){
        reRenderSections.push({
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner',
        });
    }
    if(document.getElementById('cart-icon-bubble')){
        reRenderSections.push({
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
        });
    }

    const applyNoveltyValue = await applyNovelty(
        reRenderSections.map((section) => section.section),
        window.location.pathname
    );

    if(applyNoveltyValue){
        const parsedState = JSON.parse(applyNoveltyValue);
        const getSectionInnerHTML = (html, selector = '.shopify-section') => {
            return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
        }
        reRenderSections.forEach(section => {
            const sectionElement = section.id === "cart-icon-bubble"
                ? document.getElementById(section.id)
                : document.querySelector(section.selector);
                console.log(parsedState.sections);
            sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });
    }
});
